if (!customElements.get('sticky-mobile-atc')) {
  class StickyMobileAtc extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.stickyBtn = this.querySelector('[name="add"]');
      this.mainAddBtn = null;
      this.intersectionObserver = null;
      this.mutationObserver = null;
      this.boundOnVariantChange = this.handleVariantChange.bind(this);

      if (!this.productSection || !this.stickyBtn || !('IntersectionObserver' in window)) return;

      this.bind();
    }

    disconnectedCallback() {
      this.teardown();
      this.productSection?.removeEventListener('on:variant:change', this.boundOnVariantChange);
    }

    bind() {
      this.productSection.addEventListener('on:variant:change', this.boundOnVariantChange);
      this.observeMainButton();
      this.observeFormMutations();
      this.syncFromMain();
    }

    getMainAddButton() {
      return this.productSection.querySelector('.js-product-form-main [name="add"]');
    }

    observeMainButton() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }

      this.mainAddBtn = this.getMainAddButton();
      if (!this.mainAddBtn) {
        this.toggleVisibility(true);
        return;
      }

      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.mainAddBtn) {
            this.toggleVisibility(entry.isIntersecting);
          }
        });
      });

      this.intersectionObserver.observe(this.mainAddBtn);
    }

    observeFormMutations() {
      const form = this.productSection.querySelector('.js-product-form-main');
      if (!form || !('MutationObserver' in window)) return;

      this.mutationObserver = new MutationObserver(() => {
        const nextBtn = this.getMainAddButton();
        if (nextBtn !== this.mainAddBtn) {
          this.observeMainButton();
        }
        this.syncFromMain();
      });

      this.mutationObserver.observe(form, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    handleVariantChange() {
      requestAnimationFrame(() => {
        this.observeMainButton();
        this.syncFromMain();
      });
    }

    toggleVisibility(hide) {
      this.classList.toggle('sticky-mobile-atc--out', hide);
      this.toggleAttribute('inert', hide);
      this.setAttribute('aria-hidden', hide ? 'true' : 'false');
    }

    syncFromMain() {
      if (!this.stickyBtn) return;

      this.mainAddBtn = this.mainAddBtn && this.mainAddBtn.isConnected
        ? this.mainAddBtn
        : this.getMainAddButton();

      if (!this.mainAddBtn) return;

      this.stickyBtn.disabled = this.mainAddBtn.disabled;
      this.stickyBtn.textContent = this.mainAddBtn.textContent;
      this.stickyBtn.classList.toggle('is-loading', this.mainAddBtn.classList.contains('is-loading'));
      this.stickyBtn.classList.toggle('is-success', this.mainAddBtn.classList.contains('is-success'));

      if (this.mainAddBtn.getAttribute('aria-disabled') === 'true') {
        this.stickyBtn.setAttribute('aria-disabled', 'true');
      } else {
        this.stickyBtn.removeAttribute('aria-disabled');
      }
    }

    teardown() {
      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      if (this.mutationObserver) this.mutationObserver.disconnect();
    }
  }

  customElements.define('sticky-mobile-atc', StickyMobileAtc);
}
